import * as $ from "jquery";
import * as Bloodhound from "typeahead.js";

export interface IBHOptions {
    hint?: boolean;
    highlight?: boolean;
    minLength?: number;
    source?: any;
    displayKey?: string;
    remote?: any;
    local?: any;
    limit?: number;
    templates?:any

}

export class TypeaheadService {

    public static setupTypeaheadRemote(input, url, field, displayKey?, correct?, selectedHandler?, changedHandler?, templateFn?, emptyMsg?) {

        var options: IBHOptions = TypeaheadService.bhOptions(displayKey) as any;
        options.remote = {
            url: url,
            wildcard: '%QUERY',
            filter: function (response) {
                return response[field];//.map(el => {el.name = el.name.replace('<strong>', '').replace('</strong>', ''); return el;});
            }
        };
        options.limit = 1000;
        TypeaheadService.initTypeahead(input, new Bloodhound(options), displayKey, correct, selectedHandler, changedHandler, templateFn, emptyMsg);
    }


    public static setupTypeaheadLocal(input, coll, displayKey?, correct?, selectedHandler?, changedHandler?, templateFn?) {
        var options: IBHOptions = TypeaheadService.bhOptions(displayKey) as any;
        options.local = coll;
        return TypeaheadService.initTypeahead(input, new Bloodhound(options), displayKey, correct, selectedHandler, changedHandler, templateFn);
    }

    public static destroyTypeahead(input) {
        ($(input) as any).typeahead('destroy');
    }



    public static setInputValue(selector, value, timeout?) {
        if (!timeout)
            timeout = 0;
        setTimeout(function () {
            $(selector).val(value).trigger('input').closest('.textInput').find('label').addClass('focus'); //.trigger('focus');
        }, timeout);
    }

    private static bhOptions(displayKey) {
        return {
            datumTokenizer: displayKey ? function (data) {
                return Bloodhound.tokenizers.whitespace(data[displayKey])
            } : Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace
        };
    }

    public static replaceChars(str: string) {
        return str.toLocaleLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó|ö|ő/g, 'o').replace(/ü|ű|ú/g, 'u');
    }

    public static initCustomFilterDropdown(name: string, values: Array<any>, displayKey: string, selector: string, filterFunc: Function, correct?) {
        TypeaheadService.initCustomFilterTypeAhead(name, values, displayKey, selector, filterFunc, correct, true);
    }


    public static initCustomFilterTypeAhead(name: string, values: Array<any>, displayKey: string, selector: string, filterFunc: Function, correct?, dropdown?) {

        let data = new Bloodhound({
            name: name,
            local: values,
            datumTokenizer: function (d) {
                return Bloodhound.tokenizers.whitespace(d[displayKey]);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });

        data.initialize();


        ($(selector) as any).typeahead(dropdown ? { minLength: 0 } : null, {
            name: name,
            displayKey: displayKey,
            limit: 1000,
            source: function (query, cb) {
                cb(filterFunc(query, values));
            }
        });

        $(document).on('blur', selector, (() => {
            $(selector).closest('.twitter-typeahead').hide();
            setTimeout(() => {
                ($(selector) as any).typeahead('close');
                $(selector).closest('.twitter-typeahead').show();
            }, 5);
        }));

        $(selector).bind('typeahead:select typeahead:close', function () {
            $(selector).trigger('change');
        });

        if (correct)
            TypeaheadService.correctFocus(selector);

    };

    static getEmptyMsg(emptyMsg) {
        return emptyMsg == undefined ? 
            ((self as any).translations ? (self as any).translations.products_no_matching_names: 'No matching names'): 
            emptyMsg;
    }


    public static initCustomFilterTypeAheadLocal(name: string, values: Array<any>, displayKey: string, selector: string, filterFunc: Function, correct?, dropdown?, emptyMsg?, templateFn?) {

        let data = new Bloodhound({
            name: name,
            local: values,
            datumTokenizer: function (d) {
                return Bloodhound.tokenizers.whitespace(d[displayKey]);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });

        data.initialize();


        ($(selector) as any).typeahead(dropdown ? { minLength: 0 } : null, {
            name: name,
            displayKey: displayKey,
            limit: 1000,
            source: function (query, cb) {
                cb(filterFunc(query, values));
            },templates: {
                empty:
                    `<div class="empty-message">
                    ${TypeaheadService.getEmptyMsg(emptyMsg)}
                    </div>`
                ,
                suggestion: templateFn ? templateFn : data => data
            }
        });

        
        $(document).on('blur', selector, (() => {
            $(selector).closest('.twitter-typeahead').hide();
            setTimeout(() => {
                ($(selector) as any).typeahead('close');
                $(selector).closest('.twitter-typeahead').show();
            }, 5);
        }));

        $(selector).bind('typeahead:select typeahead:close', function () {
            $(selector).trigger('change');
        });

        if (correct)
            TypeaheadService.correctFocus(selector);

    };


    private static correctFocus(input) {

        setTimeout(function () {
            $(input).focus();
            $(input).removeClass('error')
        }, 200);

    }

  


    private static initTypeahead(input, bloodHound, displayKey, correct, selectedHandler, changedHandler, templateFn?, emptyMsg?) {
        bloodHound.initialize();
        var options: IBHOptions = {
            hint: true,
            highlight: true,
            minLength: 1,
            limit: 1000,
            source: bloodHound.ttAdapter(),
            templates: {
                empty:
                    `<div class="empty-message">
                    ${TypeaheadService.getEmptyMsg(emptyMsg)}
                    </div>`
                ,
                suggestion: templateFn ? templateFn : data => data
            }
        }



        if (displayKey) {
            options.displayKey = displayKey
        }

        
        ($(input) as any).typeahead(null, options);
        $(input).bind('typeahead:select typeahead:close', function () {
            $(input).trigger('change');

        });

        if (selectedHandler) {
            ($(input) as any).change(e => selectedHandler(e));
        }
        if (changedHandler) {
            ($(input) as any).keypress(e => changedHandler(e))
        }

        if (correct)
            TypeaheadService.correctFocus(input);

    }



    private setupDropdown(list, items, input) {
        var options = $(list).find('options');
        options.html('');
        $.each(items, function (i, item) {
            options.append('<div data-value="' + item + '">' + item + '</div>')
        });
        $(options).find('div[data-option]').click(function () {
            input.val($(this).attr('data-value')).trigger('change');
        })
    }
}